var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailSendFill = function SvgMailSendFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 6.15V4.794a.9.9 0 0 1 .893-.894h16.214c.493 0 .893.4.893.894v14.413a.9.9 0 0 1-.893.893H4.393a.893.893 0 0 1-.893-.893V18.3h16.2V7.77l-7.2 6.48zM1.7 10.2h4.5V12H1.7zm0 4.5h7.2v1.8H1.7z"
  })));
};
export default SvgMailSendFill;